import { useParams } from "react-router";
import { PricingLevelsTypes } from "@/types";
import { API_URL } from "../../constants";

import { createQuery } from "../createQuery";
import { createMutate } from "../createMutate";

/**
 * Create pricint level
 */
export const useCreatePricingLevel = createMutate<PricingLevelsTypes.PricingLevelBase, PricingLevelsTypes.PricingLevelBase>(
  API_URL.PRICING_LEVEL_CREATE,
);

/**
 * Update pricint level
 */
export const useUpdatePricingLevel = createMutate<PricingLevelsTypes.PricingLevelBase, PricingLevelsTypes.PricingLevelBase>(
  API_URL.PRICING_LEVEL_UPDATE,
);

/**
 *
 * @param id : string
 * @returns the information for a specific pricing level
 */
export const useGetPricingLevel = (pricingId?: string) => {
  const { id } = useParams();
  const pricingLevelGet = createQuery<{ id: string }, PricingLevelsTypes.PricingLevelBase>(API_URL.PRICING_LEVEL_GET);

  const {
    isFetching,
    data: pricingLevel,
    refetch,
  } = pricingLevelGet(
    { id: id || pricingId },
    {
      enabled: !!id || !!pricingId,
    },
  );

  return { pricingLevel, isFetching, refetch };
};
